import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { Summary } from './summary.component';
import {
  selectCurrentExperience,
  selectExperienceContextHomeName,
  selectExperienceContextHomeRoute,
  selectSameContextExperiencesCount,
  selectSimilarExperiences,
} from '../../../modules/experience';
import { AnalyticsActions } from '../../../modules/analytics';
import { AuthActions, selectIsSignedIn } from '../../../modules/auth';

const mapStateToProps = createStructuredSelector({
  experience: selectCurrentExperience,
  currentHomeRoute: selectExperienceContextHomeRoute,
  sameMarketExperiencesLength: selectSameContextExperiencesCount,
  similarExperiences: selectSimilarExperiences,
  contextName: selectExperienceContextHomeName,
  isUserSignedIn: selectIsSignedIn,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logGTMEvent: AnalyticsActions.logGTMEvent,
      showModal: AuthActions.showModal,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(Summary);
